import cn from "classnames";

import { ProFormProps } from "./ProForm.types";

import { Loans } from "../Loans";
import { Stages } from "../Stages";
import { FormTabs } from "../FormTabs";
import { InvestObjects } from "../InvestObjects";
import { ClientParameters } from "../ClientParameters";
import { InvestObjectParameters } from "../InvestObjectParameters";

import styles from "./ProForm.module.scss";

const ProForm = ({
  isDesktop,
  calculatorType,
  calculationValues,
  loansOptions,
  loans,
  isRootAdmin,
  defaultDowntimeDynamicNotEmpty,
  tabsConfig,
  activeTab,
  onActiveTabChange,
  stagesOptions,
}: ProFormProps) => (
  <div className={styles.inner}>
    <FormTabs
      tabsConfig={tabsConfig}
      activeTab={activeTab}
      calculatorType={calculatorType}
      onActiveTabChange={onActiveTabChange}
    />
    <div
      className={cn(styles.formInner, {
        [styles.formInnerDesktop]: isDesktop,
      })}
    >
      <ClientParameters
        activeTab={activeTab}
        isDesktop={isDesktop}
        calculatorType={calculatorType}
      />
      <InvestObjectParameters
        activeTab={activeTab}
        isDesktop={isDesktop}
        isRootAdmin={isRootAdmin}
        defaultDowntimeDynamicNotEmpty={defaultDowntimeDynamicNotEmpty}
        loans={loans}
        calculatorType={calculatorType}
        loansOptions={loansOptions}
      />
      <InvestObjects
        activeTab={activeTab}
        isDesktop={isDesktop}
        isRootAdmin={isRootAdmin}
        calculatorType={calculatorType}
        calculationValues={calculationValues}
      />
      {isRootAdmin && (
        <Stages
          calculatorType={calculatorType}
          activeTab={activeTab}
          isDesktop={isDesktop}
          stagesOptions={stagesOptions}
        />
      )}
      <Loans
        activeTab={activeTab}
        isDesktop={isDesktop}
        loans={loans}
        isRootAdmin={isRootAdmin}
      />
    </div>
  </div>
);

export default ProForm;
